export const wrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
};

export const resultsStyles = {
  display: 'flex',
  flexDirection: 'column',
  maxHeight: '188px',
  overflow: 'auto',
};

export const emptyStyles = {
  padding: '12px 4px',
  color: ({ palette }) => palette.text.placeholder,
};
